import { motion } from "framer-motion";

export const SectionHeading = ({ number, title, highlight, sub, light = false }) => (
    <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ type: "spring", stiffness: 90, damping: 16 }}
        className="mb-14 max-w-3xl"
    >
        <div className="mb-5 inline-flex items-center gap-3">
            <span
                className={`flex h-11 w-11 items-center justify-center rounded-full border-2 border-monster-navy font-display text-lg font-semibold shadow-sticker-sm ${
                    light ? "bg-monster-yellow text-monster-navy" : "bg-monster-navy text-white"
                }`}
            >
                {number}
            </span>
            <span className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-monster-blue">
                Chapter {number}
            </span>
        </div>
        <h2
            className={`font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl ${
                light ? "text-white" : "text-monster-navy"
            }`}
        >
            {title} <span className="text-monster-green">{highlight}</span>
        </h2>
        {sub && <p className={`mt-5 text-base md:text-lg ${light ? "text-white/80" : "text-monster-navy/70"}`}>{sub}</p>}
    </motion.div>
);
